import { render, staticRenderFns } from "./ProxyPlans.vue?vue&type=template&id=59efedb2"
import script from "./ProxyPlans.vue?vue&type=script&lang=js"
export * from "./ProxyPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports